import { OccursIn, OccursInExtra } from '@aipb/gulliver/personal-content/model';
import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';

interface FavoriteLibServiceData {
  [serviceValue: string]: OccursInExtra;
}

interface FavoriteLibProps {
  favorites_in_service: {
    [service: string]: FavoriteLibServiceData;
  };
}

const store = createStore(
  { name: 'personal-content-favorite-lib' },
  withProps<FavoriteLibProps>({
    favorites_in_service: {}
  })
);

@Injectable({
  providedIn: 'root'
})
export class FavoriteLibRepository {
  favoritesChange$ = store.pipe(select((state) => state.favorites_in_service));

  getFavorite(service: string, serviceValue: string): OccursInExtra {
    if (!this.isFavorite(service, serviceValue)) return null;
    return store.getValue().favorites_in_service[service][serviceValue];
  }

  isFavorite(service: string, serviceValue: string): boolean {
    const favoritesInService = store.getValue().favorites_in_service;

    return service in favoritesInService && serviceValue in favoritesInService[service];
  }

  setServiceData(service: string, data: FavoriteLibServiceData) {
    store.update((state) => ({
      ...state,
      favorites_in_service: {
        ...state.favorites_in_service,
        [service]: {
          ...state.favorites_in_service[service],
          ...data
        }
      }
    }));
  }

  setServiceValueData(service: string, serviceValue: string, occursIn: OccursIn, hasRelatedNibbles: boolean) {
    store.update((state) => ({
      ...state,
      favorites_in_service: {
        ...state.favorites_in_service,
        [service]: {
          ...state.favorites_in_service[service],
          [serviceValue]: {
            ...occursIn,
            hasRelatedNibbles
          }
        }
      }
    }));
  }

  reset() {
    store.reset();
  }
}
